import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".QuickFilterPillGroup-module_quickFilterPillContainer__W8MCR {\n  margin-bottom: 18px;\n}\n\n.QuickFilterPillGroup-module_quickFilterPillWrapper__qllE5 {\n  display: inline;\n  margin-right: 12px;\n}\n\n@media (max-width: 991px) {\n  .QuickFilterPillGroup-module_quickFilterPillWrapper__qllE5 {\n    margin-right: 8px;\n  }\n}";
var Styles = {"quickFilterPillContainer":"QuickFilterPillGroup-module_quickFilterPillContainer__W8MCR","quickFilterPillWrapper":"QuickFilterPillGroup-module_quickFilterPillWrapper__qllE5"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=QuickFilterPillGroup.module.scss.js.map
